import { useEffect } from 'react';
import { useToast } from '@chakra-ui/react';

/**
 * Notification Host
 *
 * Listens for 'yap:notify' custom events (dispatched by long-running service
 * commands: clash detection, structural analysis, IFC validation, schedules)
 * and surfaces them as toasts. Centralizes command feedback for all modes.
 */
export function NotificationHost() {
    const toast = useToast();

    useEffect(() => {
        const handleNotify = (e: Event) => {
            const detail = (e as CustomEvent).detail as { message?: string; status?: 'info' | 'success' | 'warning' | 'error' };
            if (!detail?.message) return;
            toast({
                title: detail.message,
                status: detail.status ?? 'info',
                duration: 4000,
                isClosable: true,
                position: 'bottom-right',
            });
        };

        window.addEventListener('yap:notify', handleNotify);
        return () => window.removeEventListener('yap:notify', handleNotify);
    }, [toast]);

    return null;
}
